import logoPng from "assets/logo-conducco-black.png";

// `logoPng` é a URL do asset servida pelo app (dev server ou CDN do build) —
// funciona embutida na própria aplicação, mas o HTML baixado é um arquivo
// isolado que o browser abre fora desse contexto, então a URL não resolve.
// Precisa virar um data URI para o arquivo ficar autocontido.
async function resolveLogoDataUri(): Promise<string> {
  const response = await fetch(logoPng);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
}

async function injectLogo(html: string): Promise<string> {
  const logoDataUri = await resolveLogoDataUri();
  return html.replace(/cid:unique-black-logo/g, logoDataUri);
}

export async function downloadHtmlReport(html: string, filename: string): Promise<void> {
  const resolved = await injectLogo(html);
  const blob = new Blob([resolved], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = "none";

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(url);
}
